import ygreen from "../Pictures/ygreenR2.png";
import synchrony from "../Pictures/synchronyR.png";

export default function Transition() {
  return (
    <div className="Transition">
      <h1>Ask About Financing!</h1>
      <p>
        100% financing is now available! Start getting service done with no down
        payment!
      </p>
      <p>A statisfied customer is our best business strategy!</p>
      <div className="transitionImgs">
        <img src={ygreen} alt="Ygreen Financing" />
        <img className="synchrony" src={synchrony} alt="Synchrony Financing" />
      </div>
    </div>
  );
}
